import getQueryParam from './getQueryParam';

export default function getHangerKitFromUrl(): boolean {
  const hangerKit = getQueryParam('hangerKit', '0');
  return hangerKit === '1';
}
